<template>
  <v-container grid-list-xl fluid style="min-height: 434px">
    <v-layout row wrap v-if="!cargando">
      <!-- Mini Estadísticas -->
      <v-flex lg3 sm6 xs12>
        <mini-statistic
          icon="mdi-archive"
          :title="totalExpedientes.toLocaleString()"
          sub-title="Expedientes"
          color="blue"
        >
        </mini-statistic>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <mini-statistic
          icon="mdi-home-modern"
          :title="estadisticasCatastro.inmuebles.toLocaleString()"
          sub-title="Inmuebles"
          color="red"
        >
        </mini-statistic>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <mini-statistic
          icon="mdi-human-greeting"
          :title="estadisticasCatastro.participan.toLocaleString()"
          sub-title="Participan"
          color="teal"
        >
        </mini-statistic>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <mini-statistic
          icon="mdi-human-male-female"
          :title="estadisticasCatastro.inmueblesConUsuarios.toLocaleString()"
          sub-title="Ocupados"
          color="green"
        >
        </mini-statistic>
      </v-flex>

      <!-- Expedientes status -->
      <v-flex lg6 sm12 xs12>
        <v-widget title="Expedientes - Estado">
          <div slot="widget-content">
            <e-chart
              :path-option="[
                ['dataset.source', statusData],
                [
                  'color',
                  [
                    color.amber.base,
                    color.indigo.base,
                    color.pink.base,
                    color.green.base,
                    color.teal.base,
                    color.purple.base
                  ]
                ],
                ['legend.orient', 'horizontal'],
                ['legend.y', 'bottom'],
                ['xAxis.show', false],
                ['yAxis.show', false],
                ['series[0].type', 'pie'],
                ['series[0].avoidLabelOverlap', true],
                ['series[0].radius', ['50%', '70%']]
              ]"
              height="350px"
              width="100%"
            >
            </e-chart>
          </div>
        </v-widget>
      </v-flex>

      <!-- Expedientes Provincias -->
      <v-flex lg6 sm12 xs12>
        <v-widget title="Expedientes - Provincias">
          <div slot="widget-content">
            <e-chart
              :path-option="[
                ['dataset.source', provinciasData],
                [
                  'color',
                  [
                    color.lightBlue.base,
                    color.indigo.base,
                    color.pink.base,
                    color.green.base,
                    color.cyan.base,
                    color.teal.base
                  ]
                ],
                ['legend.orient', 'horizontal'],
                ['legend.y', 'bottom'],
                ['xAxis.show', false],
                ['yAxis.show', false],
                ['series[0].type', 'pie']
              ]"
              height="350px"
              width="100%"
            >
            </e-chart>
          </div>
        </v-widget>
      </v-flex>

      <!-- Expedientes Documentos -->
      <v-flex lg6 sm12 xs12>
        <list-documents :documents="documentosData"></list-documents>
      </v-flex>

      <!-- Usos -->
      <v-flex lg6 sm12 xs12>
        <v-widget title="Inmuebles - Usos">
          <div slot="widget-content">
            <e-chart
              :path-option="[
                ['dataset.source', usosData],
                [
                  'color',
                  [
                    color.amber.base,
                    color.grey.base,
                    color.pink.base,
                    color.green.base,
                    color.teal.base,
                    color.purple.base,
                    color.indigo.base
                  ]
                ],
                ['legend.orient', 'horizontal'],
                ['legend.y', 'bottom'],
                ['xAxis.show', false],
                ['yAxis.show', false],
                ['series[0].type', 'pie'],
                ['series[0].avoidLabelOverlap', true],
                ['series[0].radius', ['50%', '70%']]
              ]"
              height="350px"
              width="100%"
            >
            </e-chart>
          </div>
        </v-widget>
      </v-flex>

      <v-flex lg6 sm12 xs12>
        <v-widget title="Inmuebles - Resumen">
          <div slot="widget-content">
            <div class="echarts">
              <IEcharts :option="catastroResumen"></IEcharts>
              <!-- <IEcharts :option="catastroResumen" :loading="loading" @ready="onReady" @click="onClick"></IEcharts> -->
            </div>
          </div>
        </v-widget>
      </v-flex>
    </v-layout>
    <!-- <v-layout justify-center row wrap v-else> -->
    <v-layout v-else align-center justify-center row fill-height>
      <div
        style="width: 40vw;display: flex;justify-content: center;align-items: center;"
      >
        <div style="flex: 1 1 auto;">
          <v-img
            :resizable="true"
            :src="require('@/assets/logo_loading.gif')"
            height="150%"
          ></v-img>
        </div>
      </div>
      <!-- <v-fade-transition mode="out-in">
            </v-fade-transition> -->
    </v-layout>
  </v-container>
</template>

<script>
// import IEcharts from 'vue-echarts-v3/src/lite.js';
// import 'echarts/lib/chart/bar';
// import 'echarts/lib/component/title';
import IEcharts from "vue-echarts-v3/src/full.js";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import EChart from "@/components/chart/echart";
import ListDocuments from "@/components/widgets/ListDocuments";
import MiniStatistic from "@/components/widgets/MiniStatistic";
import { mapState } from "vuex";
export default {
  name: "resumen",
  components: {
    IEcharts,
    EChart,
    VWidget,
    ListDocuments,
    MiniStatistic
  },
  data() {
    return {
      color: Material,
      loading: false,
      bar: {
        /* title: {
                    text: ''
                }, */
        tooltip: {},
        xAxis: {
          data: [
            "Shirt",
            "Sweater",
            "Chiffon Shirt",
            "Pants",
            "High Heels",
            "Socks"
          ]
        },
        yAxis: {},
        series: [
          {
            name: "Ventas",
            type: "bar",
            data: [5, 20, 36, 10, 10, 20]
          }
        ]
      },
      literalsDocuments: [
        {
          key: "solicitud_111",
          literal: "1.1.1 Solicitud"
        },
        {
          key: "grafica_112",
          literal: "1.1.2 Consulta Gráfica Catastro"
        },
        {
          key: "anexoII_113",
          literal: "1.1.3 Anexo II Declaración Responsable"
        },
        {
          key: "iban_114",
          literal: "1.1.4 Certificado IBAN"
        },
        {
          key: "cif_121",
          literal: "1.2.1 Copia CIF"
        },
        {
          key: "anexoI_122",
          literal: "1.2.2 Anexo I Certificado de Acuerdo"
        },
        {
          key: "anexoI_123",
          literal: "1.2.3 Anexo I Relación de Locales y Viviendas"
        },
        {
          key: "residencial_125",
          literal: "1.2.5 Justifica 70% Residencial"
        },
        {
          key: "empadronamientos_126",
          literal: "1.2.6 Se tienen los empadronamientos mínimos"
        },
        {
          key: "informeTecnico",
          literal: "Informe Técnico"
        },
        {
          key: "ieeObligado",
          literal: "IEE Obligado"
        },
        {
          key: "ieeTenemos",
          literal: "IEE Tenemos"
        },
        {
          key: "obrasEficiencia",
          literal: "Obras Eficiencia Art.12"
        },
        {
          key: "obrasConservacion",
          literal: "Obras Conservación Art. 17 A y B"
        },
        {
          key: "obrasSeguridad",
          literal: "Obras Seguridad y Accesibilidad Art. 17.2"
        }
      ]
    };
  },
  computed: {
    ...mapState([
      "estadisticasExpedientes",
      "estadisticasCatastro",
      "expedientesStatus",
      "provincias"
    ]),
    statusNames() {
      const result = [
        "Iniciado",
        "Pte. Doc.",
        "Completo",
        "Presentado",
        "Concedido",
        "En Curso",
        "Fin Obra",
        "Fin Expte.",
        "En Espera",
        "Fin-Cobrado",
        "Facturado",
        "Cobrado",
        "Baja",
        "No Presentado",
        "No Concedido",
        "Paralizada Obra",
        "Act. Urgente"
      ];
      return result;
    },
    statusData() {
      const keys = Object.keys(this.estadisticasExpedientes.status);
      let result = [];
      for (const key of keys) {
        result.push({
          name: this.statusNames[key],
          value: this.estadisticasExpedientes.status[key].length
        });
      }
      return result;
    },
    provinciasData() {
      const keys = Object.keys(this.estadisticasExpedientes.provincias);
      let result = [];
      for (const key of keys) {
        result.push({
          name: this.provincias
            .filter(item => item.provinciaId === key)
            .map(item => item.provinciaName)[0],
          value: this.estadisticasExpedientes.provincias[key].length
        });
      }
      return result;
    },
    totalExpedientes() {
      const keys = Object.keys(this.estadisticasExpedientes.provincias);
      let result = 0;
      for (const key of keys) {
        result += this.estadisticasExpedientes.provincias[key].length;
      }
      return result;
    },
    documentosData() {
      const keys = Object.keys(this.estadisticasExpedientes.documentos);
      let result = [];
      for (const key of keys) {
        const valor = this.estadisticasExpedientes.documentos[key].length;
        const progress = Math.round((valor / this.totalExpedientes) * 100);
        result.push({
          name: this.literalsDocuments
            .filter(item => item.key === key)
            .map(item => item.literal)[0],
          value: valor,
          progress: progress,
          color:
            progress < 15
              ? "red"
              : progress < 25
              ? "amber"
              : progress < 50
              ? "teal"
              : "blue"
        });
      }
      return result;
    },
    catastroResumen() {
      const result = {
        tooltip: {},
        xAxis: {
          data: ["Total", "Con Usuarios", "Participan"],
          color: ["#c23531", "#2f4554", "#61a0a8"]
        },
        yAxis: {},
        series: [
          {
            name: "Inmuebles",
            type: "bar",
            data: [
              this.estadisticasCatastro.inmuebles,
              this.estadisticasCatastro.inmueblesConUsuarios,
              this.estadisticasCatastro.participan
            ],
            color: ["#c23531", "#2f4554", "#61a0a8"]
          }
        ]
      };
      return result;
    },
    usosData() {
      const keys = Object.keys(this.estadisticasCatastro.usos);
      let result = [
        {
          name: "Almacén",
          value:
            (this.estadisticasCatastro.usos["Almacen-Estacionamiento"] || 0) +
            (this.estadisticasCatastro.usos["Almacén-Estacionamiento"] || 0)
        },
        {
          name: "Hostelería",
          value: this.estadisticasCatastro.usos["Ocio y Hostelería"] || 0
        },
        {
          name: "Sanidad",
          value: this.estadisticasCatastro.usos["Sanidad y Beneficencia"] || 0
        }
      ];
      for (const key of keys) {
        if (
          !key.includes("-Estacionamiento") &&
          !key.includes("Ocio") &&
          !key.includes("Sanidad")
        ) {
          result.push({
            name: key,
            value: this.estadisticasCatastro.usos[key]
          });
        }
      }
      return result;
    },
    cargando() {
      if (this.estadisticasExpedientes && this.provincias) {
        return false;
      }
      return true;
    }
  },
  methods: {
    /*onReady(instance) {
            // console.log(instance);
        },
        onClick(event, instance, echarts) {
            // console.log(arguments);
        } */
  }
};
</script>

<style scoped>
.echarts {
  /* width: 400px; */
  height: 400px;
}
</style>
